<div
  class="sidebar-wrapper it-line-left-side w-100"
  [ngClass]="{ cc: usersService.isCallCenterUser() }"
>
  <app-avatar></app-avatar>
  <div class="sidebar-linklist-wrapper">
    <div class="link-list-wrapper">
      <ul class="link-list">
        <li>
          <h3 class="no_toc"></h3>
        </li>
        <li>
          <ng-container *ngFor="let item of menuList">
            <app-sidebar-item
              *ngIf="item.visible"
              [item]="item"
              [features]="featuresUpdate$ | async"
              [menusExpanded]="settingService?.setting?.layout?.expandedMenu"
              [sidebarActive]="sidebarService.isSidebarActive()"
              [currentRoute]="activeMenu"
              (childClick)="handleRefresh($event)"
            >
            </app-sidebar-item>
          </ng-container>
        </li>
      </ul>
    </div>
  </div>
</div>
<div class="row m-0 p-0 menu-icon">
  <button
    type="button"
    id="sidebarCollapse"
    (click)="sidebarService.onSidebarCollapse()"
    class="btn bg-transparent m-0 p-1 d-none d-sm-flex"
  >
    <i
      class="primary-color fas fa-arrow-left"
      *ngIf="!sidebarService.isSidebarActive()"
      aria-hidden=true
    ></i>
    <i
      class="primary-color fas fa-arrow-right"
      *ngIf="sidebarService.isSidebarActive()"
      aria-hidden=true
    ></i>
  </button>
</div>
